import { cn } from '@/lib/utils'

/**
 * Web Icon SVG Component (Dropdown Style)
 * An emerald web/globe icon with white globe symbol
 * Extracted from dropdown-sources.tsx to match the compact dropdown styling
 */
export function WebIcon1({ className }: { className?: string }) {
  return (
    <svg
      className={cn('corner-squircle', className)}
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Main document rectangle with rounded corners */}
      <rect x="0" y="0" width="20" height="24" rx="4" fill="#059669" />

      {/* Lighter square highlight in top-right corner */}
      <rect x="14" y="0" width="6" height="6" rx="2" fill="#10B981" />

      {/* Shadow effect */}
      <rect
        x="0"
        y="0"
        width="20"
        height="24"
        rx="4"
        fill="none"
        stroke="rgba(4, 120, 87, 0.3)"
        strokeWidth="1"
      />

      {/* Globe icon - simplified version */}
      <g fill="white" opacity="0.9">
        {/* Globe circle */}
        <circle cx="10" cy="12" r="5" stroke="white" strokeWidth="0.8" fill="none" />
        {/* Horizontal lines */}
        <line x1="5" y1="12" x2="15" y2="12" stroke="white" strokeWidth="0.8" />
        {/* Vertical arc */}
        <path
          d="M10 7 Q12 9 10 12 Q8 9 10 7"
          stroke="white"
          strokeWidth="0.8"
          fill="none"
        />
        <path
          d="M10 12 Q12 15 10 17 Q8 15 10 12"
          stroke="white"
          strokeWidth="0.8"
          fill="none"
        />
      </g>
    </svg>
  )
}
